import { useState, useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next'

// import Loader from '~components/Loader/Loader';
import Loader from '../Loader/Loader';

import { useHookStore } from '../../hook-store/store';
import { 
  createUsageBasedBilling, 
} from '../../utils/stripe/usage-based-billing-utils';

// import { SUBSCRIPTION_BACKEND_URL } from '../../App';
// import { 
//   BACKEND_URL,
//   // SUBSCRIPTION_BACKEND_URL,  
// } from '~config/endpoints';
import {
  IMAGEPHOTO_BACKENDURL
} from '../../lib/api';

import classes from './UsageBasedBilling.module.css';

function CreateUsageBasedSubscription(props) {

  const [t] = useTranslation('translation')

  const [store, dispatch] = useHookStore();
  // const { freeSizeGB } = store.bucketObjectStore;
  const { 
    usageBasedPrice,
  } = store.stripeData;

  const { gLoading } = store.uiStore;

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {

  },[]);



   const createUsageBasedHandler = async () => {
    try {
      setIsLoading(true);
      const resData = await createUsageBasedBilling(
        IMAGEPHOTO_BACKENDURL,
        localStorage.getItem('token'),
        localStorage.getItem('customerId'),
        usageBasedPrice.id,
      )

      // console.log('usage based price', result, resData);
      
      if (resData.data) {
        const usageBasedSubscription = resData.data;
        if (usageBasedSubscription.plan?.id === usageBasedPrice.id) {
           dispatch('SET_USAGEBASEDSUBSCRIPTION', usageBasedSubscription);
          
           dispatch('SHOW_NOTIFICATION', {
              status: '',
              title: 'enable usage based billing success',
              message: '',
            });

            setTimeout(() => {
              //@ts-ignore
              dispatch('CLEAR_NOTIFICATION');
            },1000 * 5);

        }
      }

      setIsLoading(false);

      return resData;

    } catch(err) {
      console.log(err);
      setIsLoading(false);
      throw err;
    }
  };

  let createUsageBasedSubscriptionBody;

  if (usageBasedPrice) {
    createUsageBasedSubscriptionBody = (
      <div>
        <div className={classes.usageBasedBillingRow}>
          {t('usageBased01', 'For some models, user need to enable usage based billing and add card information for payment.')}
          {t('usageBased02', 'User will pay based on how much user used.')}
        </div>
        <div className={classes.usageBasedBillingRow}>
          <button className='btnBase'
            disabled={isLoading}
            onClick={() => {
              createUsageBasedHandler()
            }}
          >
            {t('usageBased03', 'Enable usage based billing')}
          </button>
        </div>
        {isLoading && (
          <Loader />
        )}
      </div>
    );
  }


  return (
    <Fragment>
      <div>{createUsageBasedSubscriptionBody}</div>
    </Fragment>
  );
}

export default CreateUsageBasedSubscription;
